import { SignInData, SignOutData, SignUpData } from '../../types/miscelaneos/auth.dto'
import { SignIn, SignOut, SignUp, SIGN_IN, SIGN_OUT, SIGN_UP, AUTO_SIGN_IN, RESET_PASSWORD, SEND_PASSWORD_RECOVERY_EMAIL, CHANGE_PASSWORD, RESET_CHANGE_PASSWORD } from '../types/auth'

export const signIn = (value: SignInData): SignIn => {
  return { type: SIGN_IN, payload: value }
}

export const signUp = (value: SignUpData): SignUp => {
  return { type: SIGN_UP, payload: value }
}

export const signOut = (value: SignOutData = {}): SignOut => {
  return { type: SIGN_OUT, payload: value }
}

export const autoSignIn = () => {
  return { type: AUTO_SIGN_IN, payload: null }
}

export const sendPasswordRecoveryEmail = (payload) => {
  return { type: SEND_PASSWORD_RECOVERY_EMAIL, payload }
}

export const resetPassword = (payload) => {
  return { type: RESET_PASSWORD, payload }
}

export const changePassword = (payload) => {
  return { type: CHANGE_PASSWORD, payload }
}

export const resetChangePassword = () => {
  return { type: RESET_CHANGE_PASSWORD, payload: null }
}